<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wEECsB/images/cover.jpg?1684229399282" alt="This image is the cover for the book Murder in Wauwatosa, True Crime"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murder in Wauwatosa, True Crime
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Investigate the mysteries surrounding the brutal murder of Wauwatos's Arthur "Buddy" Schumacher Jr. A must-read for fans of true crime and Wisconsin history enthusiasts.</b></p><br/><p>In 1925, the peaceful Milwaukee suburb of <i>Wauwatosa</i> found itself involved in mystery and horror. Eight-year-old Arthur "Buddy" Schumacher Jr. was last seen by three of his friends after they hopped off a freight train they'd jumped to get a ride to a nearby swimming hole.</p> <p> For seven weeks, the community and state searched desperately to find the boy until his body was found just a mile from his house with his clothing torn and a handkerchief shoved down his throat. The police pursued several promising leads, but to no avail.</p><p> In this engaging mystery, author Paul Hoffman walks us back to the scene of the crime and through the reasons it was never solved.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Hoffman
      </h2>
      
      <p class="authorDescription body article">Paul Hoffman walks us back to the scene of the crime and through the reasons it was never solved.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f5d04640